/**
 * Recipe utility functions
 */

/**
 * Check if an image URL is valid and complete
 */
export function isValidImageUrl(url) {
  if (!url || typeof url !== 'string') return false;
  if (!url.startsWith('http')) return false;
  // Check for malformed URLs (missing extension, ends with dot, etc.)
  if (url.endsWith('.') || url.endsWith('-')) return false;
  // Must have a valid image extension
  const hasValidExtension = /\.(jpg|jpeg|png|gif|webp)($|\?)/i.test(url);
  return hasValidExtension;
}

/**
 * Check if a recipe has a valid image URL
 * Filters out recipes without images or with broken/placeholder images
 */
export function hasValidImage(recipe) {
  if (!recipe.image) return false;
  return isValidImageUrl(recipe.image);
}

/**
 * Filter out recipes without valid images
 */
export function filterRecipesWithImages(recipes) {
  return recipes.filter(hasValidImage);
}
